import { Injectable } from '@angular/core';
import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';

@Injectable()
export class DraftServiceProvider {

  constructor(
    private db_service: RcsConnectorIndexDbProvider) {}

  //Speichert einen Job als Entwurf in der Datenbank
  public save_draft(job){
    this.db_service.get_record_by_key('design', job.id).subscribe(
      result => {
        if (result){
          this.db_service.update_record('design', job, job.id);
        }else{
          this.db_service.add_record('design', job, job.id);
        }
      }
    )
  }

  // Lädt einen Entwurf aus der Datenbank
  public get_draft(job):any{
    return this.db_service.get_record_by_key('design', job.id).map(
      result => {
        if (result){
          return result;
        }
        return false;
      }
    )
  }

  public delete_safe(job){
    this.db_service.get_record_by_key('design', job.id).map(result => {
      if (result){
        let orgin_timestamp = new Date(job.write_date).getTime();
        let current_timestamp = new Date(result.write_date).getTime();
        if (current_timestamp > orgin_timestamp){
          this.db_service.delete_record('design', job.id);
        }
      }
    })
  }

  public delete(job_id, task_id){
    console.log(task_id)
    console.log(job_id)
    if (task_id == 4){
      this.db_service.delete_record('design', job_id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/draft-service/draft-service.ts